import axios from "@/api/axios";

const getClientAllList = (data) => {
    return axios
        .post('/admin/client/clients-all-list', {client: data})
        .then(response => response.data)
}

const getClientList = (page, limit) => {
    return axios
        .post('/admin/client/clients-list', {page: page, limit: limit})
        .then(response => response.data)
}

const getCardClient = (data) => {
    return axios
        .post('/admin/client/card-client', {client: data})
        .then(response => response.data)
}

const createClient = (data) => {
    return axios
        .post('/admin/client/create-client', {client: data})
        .then(response => response.data)
}

const searchClient = (data) => {
    return axios
        .post('/admin/client/search-client',{client: data})
        .then(response => response.data)
}

const updateClient = (data) => {
    return axios
        .post('/admin/client/update-client',{client: data})
        .then(response => response.data)
}

const cardInfo = data => {
    return axios
        .post('/admin/client/card-info',{card: data})
        .then(response => response.data)
}

const cardAdd = data => {
    return axios
        .post('/admin/client/card-add',{card: data})
        .then(response => response.data)
}

const cardEdit = data => {
    return axios
        .post('/admin/client/card-edit',{card: data})
        .then(response => response.data)
}

const cardUnlock = data => {
    return axios
        .post('/admin/client/card-unlock',{card: data})
        .then(response => response.data)
}

const cardBlock = data => {
    return axios
        .post('/admin/client/card-block',{card: data})
        .then(response => response.data)
}

const cardDelete = data => {
    return axios
        .post('/admin/client/card-delete',{card: data})
        .then(response => response.data)
}

const changeStatusPresence = data => {
    return axios
        .post('/admin/client/change-status-presence',{client: data})
        .then(response => response.data)
}

const getStatusList = (data) => {
    return axios
        .post('/admin/client/status-list', { status: data})
        .then(response => response.data)
}

const getClientFreezeList = (data) => {
    return axios
        .post('/admin/client/freeze-list', {data: data})
        .then(response => response.data)
}

const setClientFreezeStatus = data => {
    return axios
        .post('/admin/client/change-sleep-status',{status: data})
        .then(response => response.data)
}

const setClientUnFreezeStatus = data => {
    return axios
        .post('/admin/client/change-unsleep-status',{status: data})
        .then(response => response.data)
}


const setClientChangeOwner = data => {
    return axios
        .post('/admin/client/change-owner',{status: data})
        .then(response => response.data)
}

const clientPacks = data => {
    return axios
        .post('/admin/client/packs',{status: data})
        .then(response => response.data)
}

const clientMembership = data => {
    return axios
        .post('/admin/client/membership',{status: data})
        .then(response => response.data)
}

const clientBuyList = data => {
    return axios
        .post('/admin/client/buy-list',{status: data})
        .then(response => response.data)
}

const clientScheduleList = data => {
    return axios
        .post('/admin/client/schedule-list',{status: data})
        .then(response => response.data)
}


const clientActivateProduct = data => {
    return axios
        .post('/admin/client/activate-product',{product: data})
        .then(response => response.data)
}

const clientProductInfo = (data) => {
    return axios
        .post('/admin/client/product-info',{product: data})
        .then(response => response.data)
}

const getAccountReport = (data) => {
    return axios
        .post('/admin/client/account-reports',{client: data})
        .then(response => response.data)
}

const getModifierList = (data) => {
    return axios
        .post('/admin/client/modifier-list',{client: data})
        .then(response => response.data)
}

const getModifierTypeList = (data) => {
    return axios
        .post('/admin/client/modifier-type-list',{client: data})
        .then(response => response.data)
}

const changeNomenclature = data => {
    return axios
        .post('/admin/client/change-nomenclature',{client: data})
        .then(response => response.data)
}

const changeNomenclatureList = data => {
    return axios
        .post('/admin/client/change-nomenclature-list',{client: data})
        .then(response => response.data)
}

const saveSearchClient = data => {
    return axios
        .post('/admin/client/save-search-client',{client: data})
        .then(response => response.data)
}

const getSearchClient = data => {
    return axios
        .post('/admin/client/get-search-client',{client: data})
        .then(response => response.data)
}

const getCardHistory = data => {
    return axios
        .post('/admin/client/card-history',{client: data})
        .then(response => response.data)
}

const setChangeTime = data => {
    return axios
        .post('/admin/client/change-time',{product: data})
        .then(response => response.data)
}

const calcChangeNomenclature = data => {
    return axios
        .post('/admin/client/calc-change-nomenclature',{client: data})
        .then(response => response.data)
}

const getContractList = data => {
    return axios
        .post('/admin/client/get-contract-list',{client: data})
        .then(response => response.data)
}

const printFile = data => {
    return axios
        .post('/admin/client/print-file',{client: data})
        .then(response => response.data)
}

const saveClientFile = data => {
    return axios
        .post('/admin/client/save-client-file',{client: data})
        .then(response => response.data)
}

const getProductHistory = data => {
    return axios
        .post('/admin/client/product-history',{client: data})
        .then(response => response.data)
}

export default {
    getClientAllList,
    getClientList,
    getCardClient,
    createClient,
    searchClient,
    updateClient,
    cardInfo,
    cardAdd,
    cardEdit,
    cardUnlock,
    cardBlock,
    cardDelete,
    changeStatusPresence,
    getStatusList,
    getClientFreezeList,
    setClientFreezeStatus,
    setClientUnFreezeStatus,
    setClientChangeOwner,
    clientPacks,
    clientMembership,
    clientBuyList,
    clientScheduleList,
    clientActivateProduct,
    clientProductInfo,
    getAccountReport,
    getModifierList,
    getModifierTypeList,
    changeNomenclature,
    changeNomenclatureList,
    saveSearchClient,
    getSearchClient,
    getCardHistory,
    setChangeTime,
    calcChangeNomenclature,
    getContractList,
    printFile,
    saveClientFile,
    getProductHistory
}